import { BuyButtons, SalePrice, Drawer, VariantSku, formatMoney } from "//decked.com/cdn/shop/t/449/assets/static.theme.js?v=104424099159684732821783029010";

var AjaxDrawer = class extends Drawer {
  constructor() {
    super();
    this.loaded
  }

  get href() {
    if(this._href) return this._href;
    const url = new URL(this.getAttribute("href"), location);
    if(url.pathname.startsWith("/pages/")) {
      const searchParams = new URLSearchParams(url.search);
      searchParams.set("view", "drawer");
      url.search = searchParams.toString();
    }
    return url.toString();
  }

  async show() {
    if(!this.loaded) {
      if(this.href.indexOf("www.youtube.com/embed") > 0) {
        this.showIFrame();
      }else{
        this.getContent();
      }
    }
    super.show();
  }

  showIFrame() {
    this.classList.add("drawer--iframe");
    this.innerHTML = `<iframe src="${this.href}" frameborder="0"></iframe>`;
    this.loaded = true;
  }

  async getContent() {
    const response = await fetch(this.href, {
      method: 'GET'
    });
    const responseText = await response.text();
    this.innerHTML = responseText;
    this.loaded = true;
  }

};

if (!window.customElements.get("ajax-drawer")) {
  window.customElements.define("ajax-drawer", AjaxDrawer);
}

var VpvVariantSku = class extends VariantSku {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    this.innerText = "";

    window.addEventListener("variant:change", () => {
      this.updateText();
    });

    this._unsubSku = window.__VPV.watch(
      s => s.vehicleSelected,
      (isSelected) => {
        if (isSelected === false) this.innerText = "";
      }
    );
  }

  disconnectedCallback() {
    this._unsubSku?.();
  }

  updateText() {
    const { remainingVariants } = window.__VPV.pdp;
    const selectedVariant = remainingVariants?.length === 1 ? remainingVariants[0] : null;
    const sku = selectedVariant?.sku;
    if (sku) {
      this.innerText = `${window.themeVariables.strings.sku} ${sku}`;
      this.hidden = false;
    } else {
      this.innerText = "";
    }
  }
};
if (!window.customElements.get("vpv-variant-sku")) {
  window.customElements.define("vpv-variant-sku", VpvVariantSku);
}

var VpvSalePrice = class extends SalePrice {
  constructor() {
    super();
  }

  getPriceRange(variants) {
    let minPrice, maxPrice;

    variants.forEach(variant => {
      const variantPrice = parseFloat(variant.price.amount) * 100;

      if (!minPrice || minPrice > variantPrice) minPrice = variantPrice;
      if (!maxPrice || maxPrice < variantPrice) maxPrice = variantPrice;
    });

    if(minPrice === maxPrice) return [`${minPrice}`];
    return [`${minPrice}`, `${maxPrice}`];
  }

  connectedCallback() {
    super.connectedCallback();

    var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

    window.addEventListener("optionSelected", e => {
      
      const variants = e.detail?.filteredVariants;

      if (!variants || variants.length == 0) return;

      if(variants.length === 1) {
        const node = document.createRange().createContextualFragment(formatMoney(variants[0].priceV2.amount * 100, currencyFormat));
        this.lastChild.replaceWith(node);
        return;
      }

      const priceRange = this.getPriceRange(variants);

      const node = document.createRange().createContextualFragment(priceRange.length > 1 ? `From ${formatMoney(priceRange[0], currencyFormat)}` : formatMoney(priceRange[0], currencyFormat));
      this.lastChild.replaceWith(node);
    });

    window.addEventListener("optionsLoaded", e => {

      const variants = e.detail?.filteredVariants;

      if (!variants || variants.length == 0) return;

      if(variants.length === 1) {
        const node = document.createRange().createContextualFragment(formatMoney(variants[0].priceV2.amount * 100, currencyFormat));
        this.lastChild.replaceWith(node);
        return;
      }

      const priceRange = this.getPriceRange(variants);

      const node = document.createRange().createContextualFragment(priceRange.length > 1 ? `From ${formatMoney(priceRange[0], currencyFormat)}` : formatMoney(priceRange[0], currencyFormat));
      this.lastChild.replaceWith(node);
    });

    window.addEventListener("variantSelected", e => {
      const { priceV2 } = e.detail;
      if (priceV2?.amount) {
        const node = document.createRange().createContextualFragment(formatMoney(priceV2.amount * 100, currencyFormat));
        this.lastChild.replaceWith(node);
      }
    });
  }
};
if (!window.customElements.get("vpv-sale-price")) {
  window.customElements.define("vpv-sale-price", VpvSalePrice);
}

var VpvBuyButtons = class extends BuyButtons {
  constructor() {
    super();
    this.formNode = this.parentNode;
    this.disableAtcButton();
    this.setVehicleProps();
  }

  connectedCallback() {
    super.connectedCallback();

    // Apply initial state — watch only fires on changes, not on connect
    if (window.__VPV.store.productVehiclePickerOpen) {
      this.setAttribute("hidden", "");
    } else {
      this.removeAttribute("hidden");
    }

    this._unsubVPP = window.__VPV.watch(
      s => s.productVehiclePickerOpen,
      (isOpen) => {
        if (isOpen === false) {
          this.removeAttribute("hidden");
        } else {
          this.updateAtc();
          this.setAttribute("hidden", "");
        }
      }
    );

    window.addEventListener("optionsLoaded", e => {
      this.updateAtc();
    });

    window.addEventListener("optionSelected", e => {
      this.updateAtc();
    });

    window.addEventListener("variantSelected", e => {
      // Update product form variant ID & button text
      const newVariantId = e.detail.id;
      const variantIdInput = this.formNode.querySelector('input[name="id"]');
      if (variantIdInput) {
        variantIdInput.value = newVariantId;
      }

      this.updateAtc();
    });

  }

  updateAtc() {
    const { remainingVariants } = window.__VPV.pdp;
    const selectedVariant = remainingVariants?.length === 1 ? remainingVariants[0] : null;
    const atcTextNode = this.atcButtonNode.getAttribute("is") === "custom-button" ? this.atcButtonNode.firstElementChild : this.atcButtonNode;

    let productAvailable = false;
    remainingVariants?.forEach(variant => {
      if(variant.availableForSale) {
        productAvailable = true;
      }
    });

    if (!selectedVariant) {
      const variantIdInput = this.formNode.querySelector('input[name="id"]');

      if(variantIdInput){
        variantIdInput.value = "";
      }
    }

    if (!productAvailable) {
      let soldOutText = window.themeVariables?.strings?.soldOutButton || "Sold Out";
      if(this.getAttribute("sold-out-text")){
        soldOutText = this.getAttribute("sold-out-text");
      }
      atcTextNode.innerHTML = soldOutText;

      if(this.getAttribute("sold-out-popup") || this.getAttribute("sold-out-link")){
        this.enableSoldOutButton();
        this.atcButtonNode.classList.remove("button--subdued");
      }else{
        this.disableAtcButton();
        this.atcButtonNode.classList.add("button--subdued");
      }
    } else {
      atcTextNode.innerHTML = window.themeVariables?.strings?.addToCartButton || "Add to Cart";
      this.atcButtonNode.classList.remove("button--subdued");
      this.enableAtcButton();
    }
  }

  setVehicleProps() {
    if (typeof VehicleData == "undefined" || !VehicleData.getSelectedVehicle()) return;
    const { make, model, year, bed_length, body_style } = VehicleData.getSelectedVehicle();
    if (make && model && year) {
      this.updateOrAddLineItem("year", year);
      this.updateOrAddLineItem("model", model);
      this.updateOrAddLineItem("make", make);
      bed_length && this.updateOrAddLineItem("bed_length", bed_length);
      body_style && this.updateOrAddLineItem("body_style", body_style);
    }
  }

  updateOrAddLineItem(propKey, propValue) {
    // Updates form line item prop inputs
    const propName = `properties[_vehicle_${propKey}]`;
    let propInput = this.formNode.querySelector(`input[name="${propName}"]`);
    if (propInput) {
      propInput.setAttribute("value", propValue);
    } else {
      propInput = document.createElement("input");
      propInput.setAttribute("type", "hidden");
      propInput.setAttribute("name", propName);
      propInput.setAttribute("value", propValue);
      this.formNode.prepend(propInput);
    }
  }

};
if (!window.customElements.get("vpv-buy-buttons")) {
  window.customElements.define("vpv-buy-buttons", VpvBuyButtons);
}


export { VpvBuyButtons, VpvVariantSku, AjaxDrawer };


